import { GreenTickIcon, MicrophoneIcon, StopIcon } from "~/common/components";
import { AUDIO_MAX_DURATION } from "~/common/constants";
import { RoundButton } from "../RoundButton";

interface AudioRecorderButtonProps {
  audioUrl?: string;
  isRecording: boolean;
  recordingTime: number;
  totalDuration: number;
  maxDuration?: number;
  handleStopRecording: () => void;
  handleStartRecording: () => void;
}

export const AudioRecorderButton = ({
  audioUrl,
  isRecording,
  recordingTime,
  totalDuration,
  maxDuration = AUDIO_MAX_DURATION,
  handleStopRecording,
  handleStartRecording,
}: AudioRecorderButtonProps) => {
  if (totalDuration === maxDuration && audioUrl) {
    return <GreenTickIcon className="size-24" />;
  }

  return isRecording ? (
    <RoundButton
      id="stopRecord"
      onClick={handleStopRecording}
      type="button"
      disabled={recordingTime < 1}
    >
      <StopIcon />
    </RoundButton>
  ) : (
    <RoundButton
      id="startRecord"
      onClick={handleStartRecording}
      disabled={!!audioUrl}
      type="button"
    >
      <MicrophoneIcon />
    </RoundButton>
  );
};
